let homeView = {

    init: function() {

        this.linksCarouselInit();
        this.brandsCarouselInit();
        this.tooltipCarouselInit();
        this.productListingCarouselInit();
    },

    linksCarouselInit: function(){
        console.log('linksCarouselInit');

        jQuery('.links-carousel').parent().addClass('links-carousel-section');

        jQuery('.links-carousel-wrapper').slick({ 
            slidesToShow: 1,
            dots: false,
            arrows: true,
            centerMode: true,
            mobileFirst: true,
            variableHeight: true,
            autoplay: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        centerMode: false,
                        centerPadding: '20px',
                        slidesToShow: 3,
                    },
                },
            ]
        });
    },// links-carousel

    brandsCarouselInit: function(){
        console.log('brandsCarouselInit');
        jQuery('.brands-carousel-wrapper').slick({ 
            slidesToShow: 1,
            dots: false,
            arrows: true,
            centerMode: true,
            mobileFirst: true,
            variableHeight: true,
            autoplay: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        centerMode: false,
                        centerPadding: '20px',
                        slidesToShow: 4,
                    },
                },
            ]
        });
    },// brandsCarouselInit

    tooltipCarouselInit: function(){
        console.log('tooltipCarousel');
        jQuery('.tooltip-carousel-wrapper').slick({ 
            slidesToShow: 1,
            centerPadding: '20px',
            dots: false,
            arrows: true,
            centerMode: false,
            mobileFirst: true,
            variableHeight: true,
            autoplay: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        centerMode: false,
                        centerPadding: '20px',
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 470,
                    settings: {
                        centerMode: false,
                        centerPadding: '20px',
                        slidesToShow: 2,
                    }
                }                
            ]
        });
    },// tooltipCarouselInit

    productListingCarouselInit: function(){
        console.log('productListingCarouselInit');

        jQuery('.tabbed-carousels .tab-title').click(function(e){

            jQuery(e.currentTarget).siblings().removeClass('active');
            jQuery(e.currentTarget).addClass('active');

            let selectedTabIndex = jQuery(e.currentTarget).data('tab');
            let selectedTabContent = jQuery('.tabbed-carousels .tab-content').filter(`[data-tab="${selectedTabIndex}"]`);

            selectedTabContent.siblings().removeClass('active');
            selectedTabContent.addClass('active');

        });

        jQuery('.product-listing.as-carousel').slick({ 
            slidesToShow: 1,
            centerPadding: '20px',
            dots: false,
            arrows: true,
            centerMode: false,
            mobileFirst: true,
            variableHeight: true,
            autoplay: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        centerMode: false,
                        centerPadding: '20px',
                        slidesToShow: 4,
                        autoplay: false
                    }
                },
                {
                    breakpoint: 470,
                    settings: {
                        centerMode: false,
                        centerPadding: '20px',
                        slidesToShow: 2,
                        autoplay: false
                    }
                }                
            ]
        });
    },// productListingCarouselInit



}//homeView


homeView.init();